module.exports = __webpack_public_path__ + "static/media/img15.58f95790.JPG";